import { Link } from "react-router-dom";
import { Phone, ShieldCheck, Facebook, Instagram, Linkedin, MessageCircle } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300 py-10 mt-10 border-t border-gray-700">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-8">

        {/* Left Section - About */}
        <div>
          <h2 className="text-xl font-bold text-yellow-400 mb-4">RahulCab</h2>
          <p className="text-sm leading-relaxed">
            Your trusted cab service in Jamshedpur 🚖
            Offering safe, reliable, and comfortable rides with professional drivers.
          </p>
        </div>

        {/* Middle Section - Quick Links */}
        <div>
          <h2 className="text-xl font-bold text-yellow-400 mb-4">Quick Links</h2>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-yellow-400">Home</Link></li>
            <li><Link to="/about" className="hover:text-yellow-400">About Us</Link></li>
            <li><Link to="/services" className="hover:text-yellow-400">Services</Link></li>
            <li><Link to="/cars" className="hover:text-yellow-400">Our Cars</Link></li>
            <li><Link to="/reviews" className="hover:text-yellow-400">Reviews</Link></li>
            <li><Link to="/safety" className="hover:text-yellow-400 flex items-center gap-2"><ShieldCheck size={16}/> Safety Rules</Link></li>
            <li><Link to="/contact" className="hover:text-yellow-400">Contact</Link></li>
          </ul>
        </div>

        {/* Right Section - Contact Info */}
        <div>
          <h2 className="text-xl font-bold text-yellow-400 mb-4">Contact Us</h2>
          <ul className="space-y-2 text-sm">
            <li className="flex items-center gap-2">
              <Phone size={16} /> Booking: <a href="tel:+91771776192" className="hover:text-yellow-400">+91 77177 76192</a>
            </li>
            <li className="flex items-center gap-2">
              <MessageCircle size={16} /> WhatsApp: <a href="https://wa.me/91771776192" className="hover:text-green-400">Chat Now</a>
            </li>
            <li>Email: <a href="mailto:info@rahulcab.com" className="hover:text-yellow-400">info@rahulcab.com</a></li>
          </ul>

          {/* Social Media */}
          <div className="flex gap-4 mt-4">
            <a href="https://facebook.com" target="_blank" rel="noreferrer" className="hover:text-blue-500"><Facebook /></a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer" className="hover:text-pink-500"><Instagram /></a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="hover:text-blue-400"><Linkedin /></a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-700 mt-8 pt-4 text-center text-sm">
        © {new Date().getFullYear()} RahulCab. All Rights Reserved. | Designed by Upadhayay Ji 🚖
      </div>
    </footer>
  );
}
